





























import QRCodeStyling, {
    DrawType,
    TypeNumber,
    Mode,
    ErrorCorrectionLevel,
    DotType,
    CornerSquareType,
    CornerDotType,
} from 'qr-code-styling';
import {Component, Prop, Vue, Watch} from "vue-property-decorator";


import {qrEst} from "@/services/qrEst";
import printJS from "print-js";
import axios from "axios";

const API_URL = process.env.VUE_APP_API_PATH + '/';

@Component
export default class QrCodes extends Vue {
    plants: Record<string, any[]> = {};

    // @Watch("plants.length")
    // plantsChanged() {
    //     if (this.plants.length > 0) {
    //         this.internalPlants = [{"id": "_default"}]
    //
    //         for (const plant of this.plants) {
    //             this.internalPlants.push(plant)
    //         }
    //     }
    // }

    loaded = false

    async mounted() {
        for (const lang of this.languages) {
            console.log("here")
            await axios.get(API_URL + "api/public/plants/" + lang)
                .then(res => {
                    this.plants[lang] = res.data.map((r: any) => {
                        return {
                            id: r.id,
                            name: r.name,
                            img: API_URL + "api/public/plants/thumb/" + r.id + "?rand=" + Math.floor(Math.random() * 50000),
                            latin: r.latin
                        }
                    })
                })
        }

        this.loaded = true
    }

    languages = ["et", "en", "uk", "la"]

    flags: Record<string, string> = {
        "et": "est.png",
        "en": "eng.jpg",
        "uk": "uk.jpg",
        "la": "kids.jpg"
    }

    display = 'block'

    print() {
        this.display = 'block';


        for (const lang of this.languages) {
            for (const plant of this.plants[lang]) {
                qrEst.data = "https://hildegarden.ee/" + lang + "/plant/" + plant.id;
                qrEst.image = "https://hildegarden.ee/static/img/flags/flag_" + this.flags[lang]
                new QRCodeStyling(qrEst).append(document.getElementById('qr-' + plant.id + '-' + lang) ?? undefined)
            }
        }

        setTimeout(() => {
            printJS({
                printable: "print",
                type: "html",
                targetStyles: ["*", "page-break-after"],
                style: "@page {margin-top: 30mm}",
                font_size: "16pt"
            })

            this.display = 'none'
        }, 4000)
    }

    $refs!: {
        qrCode1: any,
        qrCode2: any,
        qrCode3: any,
        qrCode4: any
    }
}

